import { getCampaignLeads } from "@/features/campaigns/api/enrollmentsApi";
import {
  formatStepDate,
  getActionLabel,
  getTextInCapitalize,
} from "@/shared/utils/helperFunctions";
import { activities } from "@/shared/utils/utils";
import { exportTableData } from "@/shared/utils/tableExport";

export const CONTACT_ANALYSIS_EXPORT_COLUMNS = [
  { key: "name", label: "Name", accessor: (row) => row.full_name || "" },
  { key: "email", label: "Email", accessor: (row) => row.email || "" },
  { key: "company", label: "Company", accessor: (row) => row.company || "" },
  {
    key: "engagementScore",
    label: "Engagement Score",
    accessor: (row) =>
      row.runtimeEngagementScore != null
        ? `${row.runtimeEngagementScore}%`
        : "",
  },
  {
    key: "engagementStatus",
    label: "Engagement Status",
    accessor: (row) =>
      getTextInCapitalize(row.engagementStatus?.status) || "N/A",
  },
];

export const CHANNEL_VIEW_EXPORT_COLUMNS = [
  { key: "name", label: "Name", accessor: (row) => row.full_name || "" },
  { key: "email", label: "Email", accessor: (row) => row.email || "" },
  { key: "company", label: "Company", accessor: (row) => row.company || "" },
  {
    key: "designation",
    label: "Designation",
    accessor: (row) => row.designation || "",
  },
  { key: "channel", label: "Channel", accessor: (row) => row.channel || "" },
  {
    key: "step",
    label: "Step",
    accessor: (row) =>
      row.step_order != null ? `Step ${row.step_order}` : "",
  },
  {
    key: "step_action",
    label: "Action",
    accessor: (row) => (row.step_action ? getActionLabel(row.step_action) : ""),
  },
  {
    key: "engagement",
    label: "Sent/Opened/Clicked/Responded",
    accessor: (row) => formatEngagementForExport(row),
  },
];

const getLeadId = (item) => item?.id ?? item?.contact_id ?? item?.email;

function formatEngagementForExport(item) {
  const completed = activities.filter((activity) => {
    const value = item?.[activity.key] || (activity.altKey && item?.[activity.altKey]);
    return Boolean(value);
  });

  if (!completed.length) return "No Activity";

  return completed
    .map((activity) => {
      const value =
        item?.[activity.key] || (activity.altKey && item?.[activity.altKey]);
      return `${activity.label}: ${formatStepDate(value) || value}`;
    })
    .join("; ");
}

export async function fetchAllCampaignLeads(campaignId) {
  const limit = 100;
  let page = 1;
  let total = Infinity;
  const collected = [];
  const seen = new Set();

  while (collected.length < total) {
    const response = await getCampaignLeads(campaignId, page, limit, "");
    const leads = response?.leads ?? [];
    total = response?.total ?? leads.length;

    if (!leads.length) break;

    leads.forEach((lead) => {
      const id = getLeadId(lead);
      if (id && seen.has(id)) return;
      if (id) seen.add(id);
      collected.push(lead);
    });

    if (leads.length < limit || collected.length >= total) break;
    page += 1;
    if (page > 200) break;
  }

  return collected;
}

export async function exportCampaignTable({
  format,
  columns,
  rows,
  filename,
  title,
}) {
  await exportTableData({
    format,
    columns,
    rows,
    filename,
    title,
  });
}
